import { PILES_TREATMENT_CITIES } from "@/components/PilesTreatmentCityPage";
import { HERNIA_HOSPITAL_HTML, herniaHospitalFaqs } from "@/lib/hernia-hospital-gurgaon-lp";
import type { HerniaCostCity } from "@/lib/hernia-city-lp";

function localizeHospital(text: string, city: HerniaCostCity): string {
  if (city === "Gurgaon") return text;
  const original = PILES_TREATMENT_CITIES.Gurgaon;
  const local = PILES_TREATMENT_CITIES[city];
  const replacements = [
    [original.doctorImage, local.doctorImage],
    [original.doctorShortQuals, local.doctorShortQuals],
    [original.doctorEducation, local.doctorEducation],
    [original.doctorFellowships, local.doctorFellowships],
    [original.doctorRole, local.doctorRole],
    [original.mapUrl.replaceAll("&", "&amp;"), local.mapUrl.replaceAll("&", "&amp;")],
    [original.address, local.address],
    [original.addressShort, local.addressShort],
    ["Dr. N. K. Mandal", local.doctor],
    ["Senior General &amp; Laparoscopic Surgeon", local.doctorRole.replaceAll("&", "&amp;")],
    ["https://healic.in/gurgaon/piles-hospital", `https://healic.in/${city === "Muzaffarnagar" ? city : local.slug}/hernia-hospital`],
  ];
  return replacements.reduce((html, [from, to]) => html.replaceAll(from, to), text)
    .replaceAll("Gurgaon", city);
}

export function herniaHospitalHtml(city: HerniaCostCity): string {
  return localizeHospital(HERNIA_HOSPITAL_HTML, city);
}

export function herniaHospitalCityFaqs(city: HerniaCostCity) {
  return herniaHospitalFaqs.map(({ q, a }) => ({ q: localizeHospital(q, city), a: localizeHospital(a, city) }));
}